import { Grid } from '@features/dashboard/widgets/grid';
import { ColDef } from 'ag-grid-enterprise';

export const LiveMidPricesGrid = ({
  columnDefs,
  rowData,
  getRowId,
  toolPanel,
  defaultColDef,
}: {
  columnDefs: ColDef[];
  rowData: any[];
  getRowId: (params: any) => string;
  toolPanel: any;
  defaultColDef: ColDef;
}) => {
  return <Grid columnDefs={columnDefs} rowData={rowData} defaultColDef={defaultColDef} getRowId={getRowId} headerHeight={40} sideBar={toolPanel} />;
};
